import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { createGlobalStore } from "@/stores/global"

/**
 * 리포트 URL을 클립보드에 복사하고 스낵바로 결과를 알려주는 훅.
 * QuickReportWidget, RecentReportWidget 양쪽에서 사용.
 */
export function useCopyReportLink() {
  const { t } = useTranslation()
  const setSnackBar = createGlobalStore((s) => s.setSnackBar)

  const copyLink = useCallback(
    async (url: string) => {
      try {
        await navigator.clipboard.writeText(url)
        setSnackBar({
          open: true,
          message: t("linkCopied", "Link copied"),
          severity: "success",
        })
      } catch {
        setSnackBar({
          open: true,
          message: t("linkCopyFailed", "Failed to copy link"),
          severity: "error",
        })
      }
    },
    [setSnackBar, t],
  )

  return { copyLink }
}
